import styles from './resetpassword.module.css';
import { useUnit } from "effector-react";
import { Input } from "../../../../shared/ui/Input/Input";
import { $resetPasswordStore, $secondsLeft, isPending } from "../../models/store";
import { confirmResetPassword, setInputValue, setResetPasswordsStore, tick } from "../../models/events";
import { TEmailInput, TResetPasswordInputKey } from "../../models/types";
import { useNavigate } from 'react-router-dom';
import { FormEvent, useCallback, useEffect } from 'react';
import { Spinner } from '../../../../shared/ui/Spinner/Spinner';
import { Button } from '../../../../shared/ui/Button/Button';
import { ResetPasswordDescription } from '../ResetPasswordDescription/ResetPasswordDescription';
import { checkValidate } from '../../../../shared/lib/input/checkValidate';
import { NEW_RESET_PASSWORD_VALIDATION_SCHEMA } from '../../models/consts';
import { getResetPasswordTimerState } from '../../utils/getResetPasswordTimerState';


export function ResetPassword() {
    const navigate = useNavigate();
    const {
        secondsLeft,
        resetPasswordStore,
        isLoading,
    } = useUnit({
        secondsLeft: $secondsLeft,
        resetPasswordStore: $resetPasswordStore,
        isLoading: isPending,
    });

    const {
        isRequestSent,
        cooldownEnd,
        emailInput
    } = resetPasswordStore;

    const {
        showDescription,
        buttonText,
        isButtonDisabled
    } = getResetPasswordTimerState(
        secondsLeft,
        isRequestSent
    );

    useEffect(() => {
        tick();

        if (!cooldownEnd) return;

        const id = window.setInterval(tick, 1000);
        return () => window.clearInterval(id);
    }, [cooldownEnd]);

    const handleInputChange = useCallback((key: TResetPasswordInputKey, value: string) => {
        setInputValue({ key, value });
    }, []);

    async function handleResetPassword(event: FormEvent<HTMLFormElement>) {
        event.preventDefault();

        if (isButtonDisabled || isLoading) return;

        const { validate, newObj } = await checkValidate<TEmailInput>(
            { emailInput: emailInput },
            NEW_RESET_PASSWORD_VALIDATION_SCHEMA
        )

        if (validate) {
            confirmResetPassword();
        } else {
            setResetPasswordsStore({
                ...resetPasswordStore,
                emailInput: newObj.emailInput,
            });
        }
    }

    return (
        <form
            onSubmit={handleResetPassword}
            className={styles.resetPasswordForm}
        >

            <Input<TEmailInput>
                value={emailInput.value}
                onChange={handleInputChange}
                name={TResetPasswordInputKey.EMAIL_INPUT}
                isRequired
                type={'email'}
                labelText='Почта'
                wrapperClassName={styles.emailInput}
                withErrorBlock
                error={emailInput.errorMessage}
            />

            {showDescription && <div className={styles.descriptionWrapper}>
                <ResetPasswordDescription showDescription={showDescription} />
            </div>}

            <div className={styles.buttonsBlock}>
                <Button
                    type="submit"
                    disabled={isLoading || isButtonDisabled}
                    className={styles.confirmButton}
                >
                    {
                        isLoading
                            ? 	<Spinner
                                    size={20}
                                    borderSize={2}
                                    color='var(--white)'
                                />
                            :   buttonText
                    }
                </Button>
                <Button
                    variant='text'
                    type='button'
                    onClick={() => navigate('/login')}
                    color='var(--red)'
                    hoverColor='var(--red_hover)'
                >
                    Отменить
                </Button>
            </div>
        </form>
    )
}
